import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { EmailsInput } from '@/components/ui/EmailsInput';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const NotificationsEmail = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreference = useAppSelector(getUserPreferences);

  const handleChange = (emails: string[]) => {
    updateUserPreferences({ ...userPreference, emails });
  };

  return (
    <div>
      <p className="mt-2 mb-2">
        <FormattedMessage id="userPreferences.section.notifications" />
      </p>
      <EmailsInput
        emails={userPreference.emails}
        onChange={handleChange}
        dataE2e="user-preferences-notifications-emails"
      />
    </div>
  );
};

export default NotificationsEmail;
